import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';

@Component({
  selector: 'app-patru-imagini',
  templateUrl: './patru-imagini.component.html',
  styleUrls: ['./patru-imagini.component.scss']
})
export class PatruImaginiComponent implements OnInit {

  constructor(private titleService: Title, private angulartics2: Angulartics2, private meta: Meta) {
    window.location.href = 'https://4img.funbible.net';
    this.titleService.setTitle('Patru Imagini - jocul');
    this.meta.updateTag({ property: 'og:title', content: 'Patru Imagini - jocul' });
    this.meta.updateTag({
      property: 'og:description',
      // tslint:disable-next-line:max-line-length
      content: 'O activitate în care personajele biblice devin enigme ce așteaptă să fie rezolvate. Jocul a apărut din dorința de a oferi copiilor din grupa mea o activitate care să le stimuleze gândirea, prin a face conexiuni logice cu relatările biblice.'
    });
    this.meta.updateTag({
      property: 'twitter:card',
      // tslint:disable-next-line:max-line-length
      content: 'O activitate în care personajele biblice devin enigme ce așteaptă să fie rezolvate. Jocul a apărut din dorința de a oferi copiilor din grupa mea o activitate care să le stimuleze gândirea, prin a face conexiuni logice cu relatările biblice.'
    });
    this.meta.updateTag({ property: 'og:url', content: 'https://4img.funbible.net' });
    this.meta.updateTag({ property: 'og:image', content: 'https://funbible.net/assets/logo.jpg' });
    this.angulartics2.eventTrack.next({
      action: 'Patru Imagini - jocul',
      properties: { category: 'pageView' },
    });
  }

  ngOnInit(): void {
  }

}
